export function extractFrontendCommitHash(fullVersion: string): string {
  if (!fullVersion || fullVersion === 'unknown') {
    return fullVersion;
  }

  const parts = fullVersion.split('_');
  return parts.length >= 3 ? parts[parts.length - 1] : fullVersion;
}
